import { createApp, h } from "vue";
import Map from "./components/Map.vue";

const mapContainers = document.querySelectorAll(".js-map-app");
mapContainers.forEach((el) => {
  //gather props from data-attributes
  const esriKey = JSON.parse(el.dataset.esriKey);
  const view = JSON.parse(el.dataset.view);
  const dataSource = JSON.parse(el.dataset.dataSource);
  const layers = JSON.parse(el.dataset.layers);
  const idLayers = JSON.parse(el.dataset.identificationLayers);
  const idFieldNames = JSON.parse(el.dataset.identificationFieldNames);
  const legendLayerIds = JSON.parse(el.dataset.legendLayerIds);
  const years = JSON.parse(el.dataset.years);
  const clustered = JSON.parse(el.dataset.clustered);
  const highlightColor = JSON.parse(el.dataset.highlightColor);
  const layerOpacity = JSON.parse(el.dataset.layerOpacity);
  const showOpacitySlider = JSON.parse(el.dataset.showOpacitySlider);
  const app = createApp({
    components: {
      Map,
    },
    render: function () {
      return h("figure", { class: el.classList.value }, [
        h(Map, {
          esriKey: esriKey,
          dataSource: dataSource,
          layersProp: layers,
          identificationLayers: idLayers,
          identificationFieldNames: idFieldNames,
          legendLayerIds: legendLayerIds,
          years: years,
          view: view,
          clusteredProp: clustered,
          highlightColor: highlightColor,
          layerOpacityProp: layerOpacity,
          showOpacitySlider: showOpacitySlider,
        }),
      ]);
    },
  });
  app.mount(el);
});
